import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DirectivesModule } from '../../core-ui/Directives/Directives.module';
import { OldIconModule } from '../../core-ui/OldIcon/OldIcon.module';
import { TooltipModule } from '../../core-ui/Tooltip/Tooltip.module';
import { IconsModule } from '../Icons/Icons.module';
import { DropdownComponent } from './Dropdown.component';

export const DropdownModuleExports = [DropdownComponent];

@NgModule({
    declarations: [...DropdownModuleExports],
    exports: [...DropdownModuleExports],
    providers: [],
    imports: [
        CommonModule,
        OldIconModule,
        TooltipModule,
        DirectivesModule,
        IconsModule
    ]
})
export class DropdownModule {}
